import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import { CheckCircle, HighlightOff } from '@material-ui/icons';
import * as actions from '../../User/store/userActions';
import { parseURL } from '../../../sc-utilities';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Redirect } from "react-router-dom";

const styles = theme => ({
    main: {
        width: "auto",
        display: "block", // Fix IE 11 issue.
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
        [theme.breakpoints.up(400 + theme.spacing(6))]: {
            width: 400,
            marginLeft: "auto",
            marginRight: "auto"
        }
    },
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: '180px',
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`
    },
    check: {
        margin: '4px',
        color: theme.palette.success.dark,
        fontSize: 40
    },
    highligh: {
        margin: '4px', color: theme.palette.error.dark, fontSize: 40
    }

});

let timer = null;

const UnsubscribeConfirm = props => {
    const { classes, onUnsubscribe } = props;
    const [unsubscribeConfirmState, setUnsubscribeConfirmState] = useState({ checked: false, result: false, seconds: 5 });
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, redirectPath: '' });

    let searchParams = parseURL(window.location.search);
    useEffect(() => {
        const fetchResult = async () => {
            let result = await onUnsubscribe(searchParams);
            if (!result) {
                return setUnsubscribeConfirmState({ ...unsubscribeConfirmState, checked: true, result: false });
            }
            timer = setInterval(() => {
                setUnsubscribeConfirmState({ ...unsubscribeConfirmState, checked: true, result: true, seconds: unsubscribeConfirmState.seconds-- });
                if (unsubscribeConfirmState.seconds === 1) {
                    clearInterval(timer);
                    redirectHandler('/login');
                    window.location.reload();
                }
            }, 1000);
        }
        fetchResult();
        return () => { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const redirectHandler = (path) => {
        setRedirectOptions({ redirect: true, redirectPath: path })
    };

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    return (
        <main className={classes.main}>
            <CssBaseline />
            <Paper className={classes.paper}>
                <Typography component="h1" variant="h5">
                    {unsubscribeConfirmState.checked ?
                        unsubscribeConfirmState.result ? `Unsubscribe successful. You will be redirected to the login page in ${unsubscribeConfirmState.seconds} seconds...`
                            : 'Unsubscribe failed.'
                        : ''}
                </Typography>

                {unsubscribeConfirmState.checked ?
                    unsubscribeConfirmState.result ? <CheckCircle fontSize='large' className={classes.check} />
                        : <HighlightOff className={classes.highligh} />
                    : <CircularProgress style={{ fontSize: 40, marginTop: '10px' }} />
                }
            </Paper>
        </main>
    );
};

const mapDispatchToProps = dispatch => {
    return {
        onUnsubscribe: mail => dispatch(actions.confirmUnsubscribe(mail)),
    };
};

export default connect(null, mapDispatchToProps)(withStyles(styles, { withTheme: true })(UnsubscribeConfirm));
